module.exports = __webpack_public_path__ + "img/nogroupdata.c8ce6f48.svg";